import { Col, Row } from 'react-bootstrap';

//================================================================

export default function CollectionDetails({collection}){

  return(
    <>
      { collection ?
        <Row className="mb-4" xs={1}>
          {/*<Col className="h4 text-truncate mb-2">
            {collection.name || "unnamed"}
          </Col>*/}

          {/*<Col className="text-truncate">
            <b>ID:</b> {collection._id || ""}
          </Col>*/}

          <Col>
            <b>Description:</b> {collection.description || ""}
          </Col>

          <Col>
            <b>Tags:</b> {collection.tags.join(", ")}
          </Col>

          { collection.created &&
            <Col>
              <b>{"Created On: "}</b> {new Date(collection.created * 1000).toLocaleString()}
            </Col>
          }

          { collection.modified &&
            <Col>
              <b>{"Last Updated: "}</b>{new Date(collection.modified * 1000).toLocaleString()}
            </Col>
          }

          <Col>
            <b>Type:</b> {collection.type}
          </Col>

          <Col>
            {collection.is_private ? "Private" : "Public"}
          </Col>
        </Row>
        :
        <Col className="text-center">
          {"Unable to load Collection"}
        </Col>
      }
    </>
  );
}
